export default __webpack_public_path__ + "static/media/noun-feedback.1eba0f53.svg";